import React, { useEffect, useState } from "react";
import PhoneInput from "react-phone-input-2";
import _ from "lodash";
import { connect } from "react-redux";
import { Controller, useFormContext } from "react-hook-form";

import { getSelectOptions } from "../../shared/utility";
import CustomSelect from "../../shared/components/select/CustomSelect";
import CustomError from "../../shared/components/custom-error/CustomError";
import { countryAction } from "../../redux/actions";
import { defaultSchedule } from "../../constants";
import { EditIcon } from "../../assets";
import CompanyOfficeHoursForm from "../agent-signup/forms/CompanyOfficeHoursForm";
import RoundedButton from "../../shared/components/buttons/RoundedButton";

const CompanyDetails = (props) => {
  const { allCountries, getAllCountries, handleChangeEditor, isEditing } =
    props;

  const {
    register,
    formState: { errors },
    getValues,
    setValue,
    watch,
    setError,
    clearErrors,
    trigger,
  } = useFormContext();
  const [phoneLength, setPhoneLength] = useState(0);
  const [schedule, setSchedule] = useState(() =>
    _.cloneDeep(getValues("company.officeHours") ?? defaultSchedule)
  );

  const setScheduleHandle = (value) => {
    setSchedule(value);
    setValue("company.officeHours", value);
  };

  useEffect(() => {
    setSchedule(getValues("company.officeHours"));

    // eslint-disable-next-line
  }, [getValues("company.officeHours")]);

  useEffect(() => {
    if (!isEditing) {
      clearErrors("company.phoneNumber");
    } else {
      if (
        phoneLength > watch("company.phoneNumber")?.length &&
        watch("company.phoneNumber")?.length < 15
      ) {
        setError("company.phoneNumber", {
          type: "minLength",
          message: "Invalid phone number",
        });
      } else {
        clearErrors("company.phoneNumber");
      }
    }

    // eslint-disable-next-line
  }, [watch("company.phoneNumber"), isEditing]);

  useEffect(() => {
    getAllCountries();
    // eslint-disable-next-line
  }, []);

  return (
    <div className="grey-bg-wrapper">
      <div className="d-flex justify-content-between">
        <div className="heading">Company Details</div>
        {!isEditing && (
          <div
            className="edit-button pointer"
            onClick={() => handleChangeEditor(true)}
          >
            <img src={EditIcon} alt="edit-icon" />
            Edit
          </div>
        )}
      </div>

      <div className="heading sub-heading">Company/Agency Name</div>
      <div className="input-field">
        <input
          type="text"
          disabled={!isEditing}
          {...register("company.name")}
        />
        <CustomError errorMessage={errors?.company?.name?.message} />
      </div>

      <div className="heading sub-heading">Phone Number</div>
      <div className="input-field">
        <>
          <Controller
            name="company.phoneNumber"
            placeHolder="(916) 687-9606"
            rules={{ required: true }}
            render={({ field: { ref, ...field } }) => (
              <PhoneInput
                placeholder="(916) 687-9606"
                disabled={!isEditing}
                disableDropdown={!isEditing}
                {...field}
                inputExtraProps={{
                  ref,
                  required: true,
                  autoFocus: true,
                }}
                onChange={(phone, country) => {
                  setValue("company.phoneNumber", phone);
                  setPhoneLength(
                    country.format.split("").filter((char) => char === ".")
                      .length
                  );
                }}
                country={"us"} // Default country code
                masks={{ sa: '.. ... ....' }}
              />
            )}
          />
          <CustomError errorMessage={errors?.company?.phoneNumber?.message} />
        </>
      </div>
      <div className="heading sub-heading">Licence Number</div>
      <div className="input-field">
        <input
          type="text"
          disabled={!isEditing}
          {...register("company.licenseNumber")}
        />
        <CustomError errorMessage={errors?.company?.licenseNumber?.message} />
      </div>
      <div className="heading sub-heading">Website URL</div>
      <div className="input-field">
        <input disabled={!isEditing} {...register("company.websiteUrl")} />
        <CustomError errorMessage={errors?.company?.websiteUrl?.message} />
      </div>
      <div className="heading sub-heading">Office Address Line 1</div>
      <div className="input-field">
        <input
          type="text"
          disabled={!isEditing}
          {...register("company.addressLine1")}
        />

        <CustomError errorMessage={errors?.company?.addressLine1?.message} />
      </div>
      <div className="heading sub-heading">Office Address Line 2</div>
      <div className="input-field">
        <input
          type="text"
          disabled={!isEditing}
          {...register("company.addressLine2")}
        />

        <CustomError errorMessage={errors?.company?.addressLine2?.message} />
      </div>
      <div className="heading sub-heading">Country</div>
      <div className="input-field">
        <CustomSelect
          isEditing={isEditing}
          options={getSelectOptions(allCountries, "name", "id")}
          name="company.countryId"
          placeholder="Country"
        />
      </div>
      <div className="heading sub-heading">State</div>
      <div className="input-field">
        <input
          type="text"
          disabled={!isEditing}
          {...register("company.state")}
        />
        <CustomError errorMessage={errors?.company?.state?.message} />
      </div>
      <div className="heading sub-heading">City</div>
      <div className="input-field">
        <input
          type="text"
          disabled={!isEditing}
          {...register("company.city")}
        />
        <CustomError errorMessage={errors?.company?.city?.message} />
      </div>
      <div className="heading mt-4">Office Hours</div>
      {errors?.company?.officeHours && (
        <div className="error">{errors?.company?.officeHours?.message}</div>
      )}
      <CompanyOfficeHoursForm
        hideHeading
        isEditing={isEditing}
        schedule={schedule}
        setSchedule={setScheduleHandle}
        errors={errors}
        trigger={trigger}
      />

      {isEditing && (
        <div className="mt-4 d-flex justify-content-center gap-3">
          <RoundedButton className="px-4 px-md-5 py-1" type="submit">
            Update
          </RoundedButton>
          <RoundedButton
            className="px-4 px-md-5 py-1"
            variant="outlined"
            onClick={() => handleChangeEditor(false)}
          >
            Cancel
          </RoundedButton>
        </div>
      )}
    </div>
  );
};

const mapStateToProps = (state) => ({
  allCountries: state.countryReducer.allCountries,
});

const mapDispatchToProps = (dispatch) => ({
  getAllCountries: () => dispatch(countryAction.getAllCountries()),
});

export default connect(mapStateToProps, mapDispatchToProps)(CompanyDetails);
